// Vuex
import { defaultObj } from './state'

export default {
  setAppointment (state, data) {
    state.appointmentId = data.appointmentId
    state.appointmentDate = data.appointmentDate
    state.customerId = data.customerId
    state.storeNumber = data.storeNumber
    state.timezone = data.timezone
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
